import { c as t } from "../clone-CtkyC0am.mjs";
import { d as a } from "../deburr-DfF-ryFw.mjs";
const n = new RegExp("\\p{Lu}?\\p{Ll}+|[0-9]+|\\p{Lu}+(?!\\p{Ll})|\\p{Emoji_Presentation}|\\p{Extended_Pictographic}|\\p{L}+", "gu");
function p(r) {
  return Array.from(r.match(n) ?? []);
}
function c(r) {
  return p(r).map((o) => o.toLowerCase()).join("-");
}
function u(r) {
  let e = t(r ?? "");
  return e = e?.replace(/ß/g, "ss"), e = e?.replace(/ä/gi, "ae"), e = e?.replace(/ö/gi, "oe"), e = e?.replace(/ü/gi, "ue"), e = a(e).toLocaleLowerCase(), e = c(e), e;
}
export {
  u as default
};
